import {useMemo} from 'react';
import {
  AI_REVIEW_JOB_TYPE,
  SPECIAL_CHARACTERS_NOT_ALLOWED,
} from '../../constant/AiReviewConstants';
import {JobDetailFormData} from './NewJobDetail';

type ValidationFn = () => boolean;

export const useStepValidation = (
  currentStepKey: number,
  jobType: string,
  formData: JobDetailFormData,
  issueCodeTypeJobRef: any,
  isIssueCodeStepValid: boolean,
  isCreatingGroup: boolean
) => {
  const invalidCharRegex = useMemo(
    // eslint-disable-next-line security/detect-non-literal-regexp
    () => new RegExp(SPECIAL_CHARACTERS_NOT_ALLOWED.characters),
    []
  );

  const hasSpecialCharError =
    currentStepKey === 1
      ? invalidCharRegex.test(formData?.jobDetail?.jobName || '')
      : currentStepKey === 2
        ? Array.isArray(formData?.contextAndCriteria?.issueCodes) &&
          formData?.contextAndCriteria?.issueCodes?.some((issueCode) =>
            invalidCharRegex.test(issueCode.code || '')
          )
        : false;

  const validateNextStep = () => {
    if (currentStepKey === 2 && jobType === AI_REVIEW_JOB_TYPE.issueCoding) {
      if (
        issueCodeTypeJobRef.current &&
        !issueCodeTypeJobRef.current.validateAll()
      ) {
        return false;
      }
    }
    return true;
  };

  const stepValidations: Record<number, ValidationFn[]> = {
    1: [() => !formData?.jobDetail?.jobName?.trim(), () => hasSpecialCharError],
    2: [
      () => jobType === AI_REVIEW_JOB_TYPE.issueCoding && !isIssueCodeStepValid,
      () =>
        jobType === AI_REVIEW_JOB_TYPE.relevancy &&
        !formData?.contextAndCriteria?.context?.trim(),
      () =>
        jobType === AI_REVIEW_JOB_TYPE.relevancy &&
        !formData?.contextAndCriteria?.relevanceCriteria?.trim(),
    ],
  };

  const globalValidations: ValidationFn[] = [
    () => hasSpecialCharError,
    () => isCreatingGroup,
    () =>
      currentStepKey === 2
        ? issueCodeTypeJobRef.current?.isNextDisabled() || false
        : false,
  ];

  const isNextButtonDisabled = () => {
    const stepValidationFns = stepValidations[currentStepKey] || [];
    const isStepInvalid = stepValidationFns.some((fn) => fn());
    const isGlobalInvalid = globalValidations.some((fn) => fn());
    return isStepInvalid || isGlobalInvalid;
  };

  return {validateNextStep, isNextButtonDisabled, hasSpecialCharError};
};
